import en from './en.json';
import fr from './fr.json';

export const commonI18n = {
  fr,
  en,
} as const;
